import { PureComponent as t } from "react";
import e from "events";
import { FlyToInterpolator as n } from "react-map-gl";
var r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function i(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function o(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}
var a = o(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = "function" == typeof Symbol && Symbol.for,
    r = n ? Symbol.for("react.element") : 60103,
    i = n ? Symbol.for("react.portal") : 60106,
    o = n ? Symbol.for("react.fragment") : 60107,
    a = n ? Symbol.for("react.strict_mode") : 60108,
    s = n ? Symbol.for("react.profiler") : 60114,
    u = n ? Symbol.for("react.provider") : 60109,
    c = n ? Symbol.for("react.context") : 60110,
    l = n ? Symbol.for("react.async_mode") : 60111,
    h = n ? Symbol.for("react.concurrent_mode") : 60111,
    p = n ? Symbol.for("react.forward_ref") : 60112,
    f = n ? Symbol.for("react.suspense") : 60113,
    d = n ? Symbol.for("react.memo") : 60115,
    y = n ? Symbol.for("react.lazy") : 60116;
  function g(t) {
    if ("object" == typeof t && null !== t) {
      var e = t.$$typeof;
      switch (e) {
        case r:
          switch (t = t.type) {
            case l:
            case h:
            case o:
            case s:
            case a:
            case f:
              return t;
            default:
              switch (t = t && t.$$typeof) {
                case c:
                case p:
                case u:
                  return t;
                default:
                  return e;
              }
          }
        case y:
        case d:
        case i:
          return e;
      }
    }
  }
  function m(t) {
    return g(t) === h;
  }
  e.typeOf = g, e.AsyncMode = l, e.ConcurrentMode = h, e.ContextConsumer = c, e.ContextProvider = u, e.Element = r, e.ForwardRef = p, e.Fragment = o, e.Lazy = y, e.Memo = d, e.Portal = i, e.Profiler = s, e.StrictMode = a, e.Suspense = f, e.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === o || t === h || t === s || t === a || t === f || "object" == typeof t && null !== t && (t.$$typeof === y || t.$$typeof === d || t.$$typeof === u || t.$$typeof === c || t.$$typeof === p);
  }, e.isAsyncMode = function (t) {
    return m(t) || g(t) === l;
  }, e.isConcurrentMode = m, e.isContextConsumer = function (t) {
    return g(t) === c;
  }, e.isContextProvider = function (t) {
    return g(t) === u;
  }, e.isElement = function (t) {
    return "object" == typeof t && null !== t && t.$$typeof === r;
  }, e.isForwardRef = function (t) {
    return g(t) === p;
  }, e.isFragment = function (t) {
    return g(t) === o;
  }, e.isLazy = function (t) {
    return g(t) === y;
  }, e.isMemo = function (t) {
    return g(t) === d;
  }, e.isPortal = function (t) {
    return g(t) === i;
  }, e.isProfiler = function (t) {
    return g(t) === s;
  }, e.isStrictMode = function (t) {
    return g(t) === a;
  }, e.isSuspense = function (t) {
    return g(t) === f;
  };
});
i(a);
var s = o(function (t, e) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = "function" == typeof Symbol && Symbol.for,
      n = t ? Symbol.for("react.element") : 60103,
      r = t ? Symbol.for("react.portal") : 60106,
      i = t ? Symbol.for("react.fragment") : 60107,
      o = t ? Symbol.for("react.strict_mode") : 60108,
      a = t ? Symbol.for("react.profiler") : 60114,
      s = t ? Symbol.for("react.provider") : 60109,
      u = t ? Symbol.for("react.context") : 60110,
      c = t ? Symbol.for("react.async_mode") : 60111,
      l = t ? Symbol.for("react.concurrent_mode") : 60111,
      h = t ? Symbol.for("react.forward_ref") : 60112,
      p = t ? Symbol.for("react.suspense") : 60113,
      f = t ? Symbol.for("react.memo") : 60115,
      d = t ? Symbol.for("react.lazy") : 60116,
      y = function y(t) {
        for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
          n[r - 1] = arguments[r];
        }
        var i = 0,
          o = "Warning: " + t.replace(/%s/g, function () {
            return n[i++];
          });
        "undefined" != typeof console && console.warn(o);
        try {
          throw new Error(o);
        } catch (t) {}
      };
    function g(t) {
      if ("object" == typeof t && null !== t) {
        var e = t.$$typeof;
        switch (e) {
          case n:
            var y = t.type;
            switch (y) {
              case c:
              case l:
              case i:
              case a:
              case o:
              case p:
                return y;
              default:
                var g = y && y.$$typeof;
                switch (g) {
                  case u:
                  case h:
                  case s:
                    return g;
                  default:
                    return e;
                }
            }
          case d:
          case f:
          case r:
            return e;
        }
      }
    }
    var m = c,
      v = l,
      b = u,
      _ = s,
      x = n,
      w = h,
      E = i,
      M = d,
      O = f,
      j = r,
      P = a,
      S = o,
      k = p,
      R = !1;
    function C(t) {
      return g(t) === l;
    }
    e.typeOf = g, e.AsyncMode = m, e.ConcurrentMode = v, e.ContextConsumer = b, e.ContextProvider = _, e.Element = x, e.ForwardRef = w, e.Fragment = E, e.Lazy = M, e.Memo = O, e.Portal = j, e.Profiler = P, e.StrictMode = S, e.Suspense = k, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === i || t === l || t === a || t === o || t === p || "object" == typeof t && null !== t && (t.$$typeof === d || t.$$typeof === f || t.$$typeof === s || t.$$typeof === u || t.$$typeof === h);
    }, e.isAsyncMode = function (t) {
      return R || (R = !0, function (t, e) {
        if (void 0 === e) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
        if (!t) {
          for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) {
            r[i - 2] = arguments[i];
          }
          y.apply(void 0, [e].concat(r));
        }
      }(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(t) || g(t) === c;
    }, e.isConcurrentMode = C, e.isContextConsumer = function (t) {
      return g(t) === u;
    }, e.isContextProvider = function (t) {
      return g(t) === s;
    }, e.isElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === n;
    }, e.isForwardRef = function (t) {
      return g(t) === h;
    }, e.isFragment = function (t) {
      return g(t) === i;
    }, e.isLazy = function (t) {
      return g(t) === d;
    }, e.isMemo = function (t) {
      return g(t) === f;
    }, e.isPortal = function (t) {
      return g(t) === r;
    }, e.isProfiler = function (t) {
      return g(t) === a;
    }, e.isStrictMode = function (t) {
      return g(t) === o;
    }, e.isSuspense = function (t) {
      return g(t) === p;
    };
  }();
});
i(s);
var u = o(function (t) {
    t.exports = "production" === process.env.NODE_ENV ? a : s;
  }),
  c = Object.getOwnPropertySymbols,
  l = Object.prototype.hasOwnProperty,
  h = Object.prototype.propertyIsEnumerable;
function p(t) {
  if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
var f = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
      for (var e = {}, n = 0; n < 10; n++) {
        e["_" + String.fromCharCode(n)] = n;
      }
      if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        r[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var n, r, i = p(t), o = 1; o < arguments.length; o++) {
      for (var a in n = Object(arguments[o])) {
        l.call(n, a) && (i[a] = n[a]);
      }
      if (c) {
        r = c(n);
        for (var s = 0; s < r.length; s++) {
          h.call(n, r[s]) && (i[r[s]] = n[r[s]]);
        }
      }
    }
    return i;
  },
  d = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  y = function y() {};
if ("production" !== process.env.NODE_ENV) {
  var g = d,
    m = {},
    v = Function.call.bind(Object.prototype.hasOwnProperty);
  y = function y(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);
    try {
      throw new Error(e);
    } catch (t) {}
  };
}
function b(t, e, n, r, i) {
  if ("production" !== process.env.NODE_ENV) for (var o in t) {
    if (v(t, o)) {
      var a;
      try {
        if ("function" != typeof t[o]) {
          var s = Error((r || "React class") + ": " + n + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[o] + "`.");
          throw s.name = "Invariant Violation", s;
        }
        a = t[o](e, o, r, n, null, g);
      } catch (t) {
        a = t;
      }
      if (!a || a instanceof Error || y((r || "React class") + ": type specification of " + n + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in m)) {
        m[a.message] = !0;
        var u = i ? i() : "";
        y("Failed " + n + " type: " + a.message + (null != u ? u : ""));
      }
    }
  }
}
b.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (m = {});
};
var _ = b,
  x = Function.call.bind(Object.prototype.hasOwnProperty),
  w = function w() {};
function E() {
  return null;
}
function M() {}
function O() {}
"production" !== process.env.NODE_ENV && (w = function w(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {}
}), O.resetWarningCache = M;
var j = o(function (t) {
    t.exports = "production" !== process.env.NODE_ENV ? function (t, e) {
      var n = "function" == typeof Symbol && Symbol.iterator,
        r = "@@iterator",
        i = "<<anonymous>>",
        o = {
          array: l("array"),
          bool: l("boolean"),
          func: l("function"),
          number: l("number"),
          object: l("object"),
          string: l("string"),
          symbol: l("symbol"),
          any: c(E),
          arrayOf: function arrayOf(t) {
            return c(function (e, n, r, i, o) {
              if ("function" != typeof t) return new s("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
              var a = e[n];
              if (!Array.isArray(a)) return new s("Invalid " + i + " `" + o + "` of type `" + p(a) + "` supplied to `" + r + "`, expected an array.");
              for (var u = 0; u < a.length; u++) {
                var c = t(a, u, r, i, o + "[" + u + "]", d);
                if (c instanceof Error) return c;
              }
              return null;
            });
          },
          element: c(function (e, n, r, i, o) {
            var a = e[n];
            return t(a) ? null : new s("Invalid " + i + " `" + o + "` of type `" + p(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
          }),
          elementType: c(function (t, e, n, r, i) {
            var o = t[e];
            return u.isValidElementType(o) ? null : new s("Invalid " + r + " `" + i + "` of type `" + p(o) + "` supplied to `" + n + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(t) {
            return c(function (e, n, r, o, a) {
              var u;
              return e[n] instanceof t ? null : new s("Invalid " + o + " `" + a + "` of type `" + ((u = e[n]).constructor && u.constructor.name ? u.constructor.name : i) + "` supplied to `" + r + "`, expected instance of `" + (t.name || i) + "`.");
            });
          },
          node: c(function (t, e, n, r, i) {
            return h(t[e]) ? null : new s("Invalid " + r + " `" + i + "` supplied to `" + n + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(t) {
            return c(function (e, n, r, i, o) {
              if ("function" != typeof t) return new s("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
              var a = e[n],
                u = p(a);
              if ("object" !== u) return new s("Invalid " + i + " `" + o + "` of type `" + u + "` supplied to `" + r + "`, expected an object.");
              for (var c in a) {
                if (x(a, c)) {
                  var l = t(a, c, r, i, o + "." + c, d);
                  if (l instanceof Error) return l;
                }
              }
              return null;
            });
          },
          oneOf: function oneOf(t) {
            return Array.isArray(t) ? c(function (e, n, r, i, o) {
              for (var u = e[n], c = 0; c < t.length; c++) {
                if (a(u, t[c])) return null;
              }
              var l = JSON.stringify(t, function (t, e) {
                return "symbol" === y(e) ? String(e) : e;
              });
              return new s("Invalid " + i + " `" + o + "` of value `" + String(u) + "` supplied to `" + r + "`, expected one of " + l + ".");
            }) : ("production" !== process.env.NODE_ENV && w(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), E);
          },
          oneOfType: function oneOfType(t) {
            if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && w("Invalid argument supplied to oneOfType, expected an instance of array."), E;
            for (var e = 0; e < t.length; e++) {
              var n = t[e];
              if ("function" != typeof n) return w("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + g(n) + " at index " + e + "."), E;
            }
            return c(function (e, n, r, i, o) {
              for (var a = 0; a < t.length; a++) {
                if (null == (0, t[a])(e, n, r, i, o, d)) return null;
              }
              return new s("Invalid " + i + " `" + o + "` supplied to `" + r + "`.");
            });
          },
          shape: function shape(t) {
            return c(function (e, n, r, i, o) {
              var a = e[n],
                u = p(a);
              if ("object" !== u) return new s("Invalid " + i + " `" + o + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");
              for (var c in t) {
                var l = t[c];
                if (l) {
                  var h = l(a, c, r, i, o + "." + c, d);
                  if (h) return h;
                }
              }
              return null;
            });
          },
          exact: function exact(t) {
            return c(function (e, n, r, i, o) {
              var a = e[n],
                u = p(a);
              if ("object" !== u) return new s("Invalid " + i + " `" + o + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");
              var c = f({}, e[n], t);
              for (var l in c) {
                var h = t[l];
                if (!h) return new s("Invalid " + i + " `" + o + "` key `" + l + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(e[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
                var y = h(a, l, r, i, o + "." + l, d);
                if (y) return y;
              }
              return null;
            });
          }
        };
      function a(t, e) {
        return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
      }
      function s(t) {
        this.message = t, this.stack = "";
      }
      function c(t) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          r = 0;
        function o(o, a, u, c, l, h, p) {
          if (c = c || i, h = h || u, p !== d) {
            if (e) {
              var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw f.name = "Invariant Violation", f;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var y = c + ":" + u;
              !n[y] && r < 3 && (w("You are manually calling a React.PropTypes validation function for the `" + h + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[y] = !0, r++);
            }
          }
          return null == a[u] ? o ? new s(null === a[u] ? "The " + l + " `" + h + "` is marked as required in `" + c + "`, but its value is `null`." : "The " + l + " `" + h + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : t(a, u, c, l, h);
        }
        var a = o.bind(null, !1);
        return a.isRequired = o.bind(null, !0), a;
      }
      function l(t) {
        return c(function (e, n, r, i, o, a) {
          var u = e[n];
          return p(u) !== t ? new s("Invalid " + i + " `" + o + "` of type `" + y(u) + "` supplied to `" + r + "`, expected `" + t + "`.") : null;
        });
      }
      function h(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(h);
            if (null === e || t(e)) return !0;
            var i = function (t) {
              var i = e && (n && e[n] || e[r]);
              if ("function" == typeof i) return i;
            }();
            if (!i) return !1;
            var o,
              a = i.call(e);
            if (i !== e.entries) {
              for (; !(o = a.next()).done;) {
                if (!h(o.value)) return !1;
              }
            } else for (; !(o = a.next()).done;) {
              var s = o.value;
              if (s && !h(s[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function p(t) {
        var e = typeof t;
        return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
          return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
        }(e, t) ? "symbol" : e;
      }
      function y(t) {
        if (null == t) return "" + t;
        var e = p(t);
        if ("object" === e) {
          if (t instanceof Date) return "date";
          if (t instanceof RegExp) return "regexp";
        }
        return e;
      }
      function g(t) {
        var e = y(t);
        switch (e) {
          case "array":
          case "object":
            return "an " + e;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + e;
          default:
            return e;
        }
      }
      return s.prototype = Error.prototype, o.checkPropTypes = _, o.resetWarningCache = _.resetWarningCache, o.PropTypes = o, o;
    }(u.isElement, !0) : function () {
      function t(t, e, n, r, i, o) {
        if (o !== d) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }
      function e() {
        return t;
      }
      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: O,
        resetWarningCache: M
      };
      return n.PropTypes = n, n;
    }();
  }),
  P = function P() {
    for (var t = {}, e = 0; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) {
        S.call(n, r) && (t[r] = n[r]);
      }
    }
    return t;
  },
  S = Object.prototype.hasOwnProperty,
  k = o(function (t, e) {
    !function () {
      var e = {};
      t.exports = e, e.simpleFilter = function (t, n) {
        return n.filter(function (n) {
          return e.test(t, n);
        });
      }, e.test = function (t, n) {
        return null !== e.match(t, n);
      }, e.match = function (t, e, n) {
        var r,
          i = 0,
          o = [],
          a = e.length,
          s = 0,
          u = 0,
          c = (n = n || {}).pre || "",
          l = n.post || "",
          h = n.caseSensitive && e || e.toLowerCase();
        t = n.caseSensitive && t || t.toLowerCase();
        for (var p = 0; p < a; p++) {
          r = e[p], h[p] === t[i] ? (r = c + r + l, i += 1, u += 1 + u) : u = 0, s += u, o[o.length] = r;
        }
        return i === t.length ? (s = h === t ? Infinity : s, {
          rendered: o.join(""),
          score: s
        }) : null;
      }, e.filter = function (t, n, r) {
        return n && 0 !== n.length ? "string" != typeof t ? n : (r = r || {}, n.reduce(function (n, i, o, a) {
          var s = i;
          r.extract && (s = r.extract(i));
          var u = e.match(t, s, r);
          return null != u && (n[n.length] = {
            string: u.rendered,
            score: u.score,
            index: o,
            original: i
          }), n;
        }, []).sort(function (t, e) {
          return e.score - t.score || t.index - e.index;
        })) : [];
      };
    }();
  }),
  R = function R(t) {
    return this.component = t, this.items = [], this.active = 0, this.wrapper = document.createElement("div"), this.wrapper.className = "suggestions-wrapper", this.element = document.createElement("ul"), this.element.className = "suggestions", this.wrapper.appendChild(this.element), this.selectingListItem = !1, t.el.parentNode.insertBefore(this.wrapper, t.el.nextSibling), this;
  };
R.prototype.show = function () {
  this.element.style.display = "block";
}, R.prototype.hide = function () {
  this.element.style.display = "none";
}, R.prototype.add = function (t) {
  this.items.push(t);
}, R.prototype.clear = function () {
  this.items = [], this.active = 0;
}, R.prototype.isEmpty = function () {
  return !this.items.length;
}, R.prototype.isVisible = function () {
  return "block" === this.element.style.display;
}, R.prototype.draw = function () {
  if (this.element.innerHTML = "", 0 !== this.items.length) {
    for (var t = 0; t < this.items.length; t++) {
      this.drawItem(this.items[t], this.active === t);
    }
    this.show();
  } else this.hide();
}, R.prototype.drawItem = function (t, e) {
  var n = document.createElement("li"),
    r = document.createElement("a");
  e && (n.className += " active"), r.innerHTML = t.string, n.appendChild(r), this.element.appendChild(n), n.addEventListener("mousedown", function () {
    this.selectingListItem = !0;
  }.bind(this)), n.addEventListener("mouseup", function () {
    this.handleMouseUp.call(this, t);
  }.bind(this));
}, R.prototype.handleMouseUp = function (t) {
  this.selectingListItem = !1, this.component.value(t.original), this.clear(), this.draw();
}, R.prototype.move = function (t) {
  this.active = t, this.draw();
}, R.prototype.previous = function () {
  this.move(0 === this.active ? this.items.length - 1 : this.active - 1);
}, R.prototype.next = function () {
  this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
}, R.prototype.drawError = function (t) {
  var e = document.createElement("li");
  e.innerHTML = t, this.element.appendChild(e), this.show();
};
var C = R,
  A = function A(t, e, n) {
    return this.options = P({
      minLength: 2,
      limit: 5,
      filter: !0
    }, n = n || {}), this.el = t, this.data = e || [], this.list = new C(this), this.query = "", this.selected = null, this.list.draw(), this.el.addEventListener("keyup", function (t) {
      this.handleKeyUp(t.keyCode);
    }.bind(this), !1), this.el.addEventListener("keydown", function (t) {
      this.handleKeyDown(t);
    }.bind(this)), this.el.addEventListener("focus", function () {
      this.handleFocus();
    }.bind(this)), this.el.addEventListener("blur", function () {
      this.handleBlur();
    }.bind(this)), this.el.addEventListener("paste", function (t) {
      this.handlePaste(t);
    }.bind(this)), this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this), this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this), this;
  };
A.prototype.handleKeyUp = function (t) {
  40 !== t && 38 !== t && 27 !== t && 13 !== t && 9 !== t && this.handleInputChange(this.el.value);
}, A.prototype.handleKeyDown = function (t) {
  switch (t.keyCode) {
    case 13:
    case 9:
      this.list.isEmpty() || (this.list.isVisible() && t.preventDefault(), this.value(this.list.items[this.list.active].original), this.list.hide());
      break;
    case 27:
      this.list.isEmpty() || this.list.hide();
      break;
    case 38:
      this.list.previous();
      break;
    case 40:
      this.list.next();
  }
}, A.prototype.handleBlur = function () {
  this.list.selectingListItem || this.list.hide();
}, A.prototype.handlePaste = function (t) {
  if (t.clipboardData) this.handleInputChange(t.clipboardData.getData("Text"));else {
    var e = this;
    setTimeout(function () {
      e.handleInputChange(t.target.value);
    }, 100);
  }
}, A.prototype.handleInputChange = function (t) {
  this.query = this.normalize(t), this.list.clear(), this.query.length < this.options.minLength ? this.list.draw() : this.getCandidates(function (t) {
    for (var e = 0; e < t.length && (this.list.add(t[e]), e !== this.options.limit - 1); e++) {
      ;
    }
    this.list.draw();
  }.bind(this));
}, A.prototype.handleFocus = function () {
  this.list.isEmpty() || this.list.show(), this.list.selectingListItem = !1;
}, A.prototype.update = function (t) {
  this.data = t, this.handleKeyUp();
}, A.prototype.clear = function () {
  this.data = [], this.list.clear();
}, A.prototype.normalize = function (t) {
  return t.toLowerCase();
}, A.prototype.match = function (t, e) {
  return t.indexOf(e) > -1;
}, A.prototype.value = function (t) {
  if (this.selected = t, this.el.value = this.getItemValue(t), document.createEvent) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent("change", !0, !1), this.el.dispatchEvent(e);
  } else this.el.fireEvent("onchange");
}, A.prototype.getCandidates = function (t) {
  var e = {
    pre: "<strong>",
    post: "</strong>",
    extract: function (t) {
      return this.getItemValue(t);
    }.bind(this)
  };
  t(this.options.filter ? k.filter(this.query, this.data, e).map(function (t) {
    return {
      original: t.original,
      string: this.render(t.original, t.string)
    };
  }.bind(this)) : this.data.map(function (t) {
    return {
      original: t,
      string: this.render(t)
    };
  }.bind(this)));
}, A.prototype.getItemValue = function (t) {
  return t;
}, A.prototype.render = function (t, e) {
  if (e) return e;
  for (var n = this.getItemValue(t.original ? t.original : t), r = this.normalize(n), i = r.lastIndexOf(this.query); i > -1;) {
    var o = i + this.query.length;
    n = n.slice(0, i) + "<strong>" + n.slice(i, o) + "</strong>" + n.slice(o), i = r.slice(0, i).lastIndexOf(this.query);
  }
  return n;
}, A.prototype.renderError = function (t) {
  this.list.drawError(t);
};
var T = A,
  I = o(function (t) {
    window.Suggestions = t.exports = T;
  }),
  L = NaN,
  N = "[object Symbol]",
  q = /^\s+|\s+$/g,
  F = /^[-+]0x[0-9a-f]+$/i,
  z = /^0b[01]+$/i,
  B = /^0o[0-7]+$/i,
  V = parseInt,
  D = "object" == typeof r && r && r.Object === Object && r,
  $ = "object" == typeof self && self && self.Object === Object && self,
  G = D || $ || Function("return this")(),
  U = Object.prototype.toString,
  Z = Math.max,
  Q = Math.min,
  H = function H() {
    return G.Date.now();
  };
function W(t) {
  var e = typeof t;
  return !!t && ("object" == e || "function" == e);
}
function K(t) {
  if ("number" == typeof t) return t;
  if (function (t) {
    return "symbol" == typeof t || function (t) {
      return !!t && "object" == typeof t;
    }(t) && U.call(t) == N;
  }(t)) return L;
  if (W(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = W(e) ? e + "" : e;
  }
  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(q, "");
  var n = z.test(t);
  return n || B.test(t) ? V(t.slice(2), n ? 2 : 8) : F.test(t) ? L : +t;
}
var J = {
    fr: {
      name: "France",
      bbox: [[-4.59235, 41.380007], [9.560016, 51.148506]]
    },
    us: {
      name: "United States",
      bbox: [[-171.791111, 18.91619], [-66.96466, 71.357764]]
    },
    ru: {
      name: "Russia",
      bbox: [[19.66064, 41.151416], [190.10042, 81.2504]]
    },
    ca: {
      name: "Canada",
      bbox: [[-140.99778, 41.675105], [-52.648099, 83.23324]]
    }
  },
  Y = function Y(t) {
    return t ? t.split(/,\s*</).reduce(function (t, e) {
      var n = function (t) {
        var e = t.match(/<?([^>]*)>(.*)/);
        if (!e) return null;
        var n = e[1],
          r = e[2].split(";"),
          i = null,
          o = r.reduce(function (t, e) {
            var n = function (t) {
              var e = t.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
              return e ? {
                key: e[1],
                value: e[2]
              } : null;
            }(e);
            return n ? "rel" === n.key ? (i || (i = n.value), t) : (t[n.key] = n.value, t) : t;
          }, {});
        return i ? {
          url: n,
          rel: i,
          params: o
        } : null;
      }(e);
      return n ? (n.rel.split(/\s+/).forEach(function (e) {
        t[e] || (t[e] = {
          url: n.url,
          params: n.params
        });
      }), t) : t;
    }, {}) : {};
  };
function X(t, e) {
  this.request = t, this.headers = e.headers, this.rawBody = e.body, this.statusCode = e.statusCode;
  try {
    this.body = JSON.parse(e.body || "{}");
  } catch (t) {
    this.body = e.body;
  }
  this.links = Y(this.headers.link);
}
X.prototype.hasNextPage = function () {
  return !!this.links.next;
}, X.prototype.nextPage = function () {
  return this.hasNextPage() ? this.request._extend({
    path: this.links.next.url
  }) : null;
};
var tt = X,
  et = {
    API_ORIGIN: "https://api.mapbox.com",
    EVENT_PROGRESS_DOWNLOAD: "downloadProgress",
    EVENT_PROGRESS_UPLOAD: "uploadProgress",
    EVENT_ERROR: "error",
    EVENT_RESPONSE: "response",
    ERROR_HTTP: "HttpError",
    ERROR_REQUEST_ABORTED: "RequestAbortedError"
  },
  nt = function nt(t) {
    var e,
      n = t.type || et.ERROR_HTTP;
    if (t.body) try {
      e = JSON.parse(t.body);
    } catch (n) {
      e = t.body;
    } else e = null;
    var r = t.message || null;
    r || ("string" == typeof e ? r = e : e && "string" == typeof e.message ? r = e.message : n === et.ERROR_REQUEST_ABORTED && (r = "Request aborted")), this.message = r, this.type = n, this.statusCode = t.statusCode || null, this.request = t.request, this.body = e;
  },
  rt = {};
function it(t) {
  var e = t.total,
    n = t.loaded;
  return {
    total: e,
    transferred: n,
    percent: 100 * n / e
  };
}
var ot = o(function (t, e) {
    !function (n) {
      var i = e,
        o = t && t.exports == i && t,
        a = "object" == typeof r && r;
      a.global !== a && a.window !== a || (n = a);
      var s = function s(t) {
        this.message = t;
      };
      (s.prototype = new Error()).name = "InvalidCharacterError";
      var u = function u(t) {
          throw new s(t);
        },
        c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
        l = /[\t\n\f\r ]/g,
        h = {
          encode: function encode(t) {
            t = String(t), /[^\0-\xFF]/.test(t) && u("The string to be encoded contains characters outside of the Latin1 range.");
            for (var e, n, r, i, o = t.length % 3, a = "", s = -1, l = t.length - o; ++s < l;) {
              e = t.charCodeAt(s) << 16, n = t.charCodeAt(++s) << 8, r = t.charCodeAt(++s), a += c.charAt((i = e + n + r) >> 18 & 63) + c.charAt(i >> 12 & 63) + c.charAt(i >> 6 & 63) + c.charAt(63 & i);
            }
            return 2 == o ? (e = t.charCodeAt(s) << 8, n = t.charCodeAt(++s), a += c.charAt((i = e + n) >> 10) + c.charAt(i >> 4 & 63) + c.charAt(i << 2 & 63) + "=") : 1 == o && (i = t.charCodeAt(s), a += c.charAt(i >> 2) + c.charAt(i << 4 & 63) + "=="), a;
          },
          decode: function decode(t) {
            var e = (t = String(t).replace(l, "")).length;
            e % 4 == 0 && (e = (t = t.replace(/==?$/, "")).length), (e % 4 == 1 || /[^+a-zA-Z0-9\/]/.test(t)) && u("Invalid character: the string to be decoded is not correctly encoded.");
            for (var n, r, i = 0, o = "", a = -1; ++a < e;) {
              r = c.indexOf(t.charAt(a)), n = i % 4 ? 64 * n + r : r, i++ % 4 && (o += String.fromCharCode(255 & n >> (-2 * i & 6)));
            }
            return o;
          },
          version: "0.1.0"
        };
      if (i && !i.nodeType) {
        if (o) o.exports = h;else for (var p in h) {
          h.hasOwnProperty(p) && (i[p] = h[p]);
        }
      } else n.base64 = h;
    }(r);
  }),
  at = {};
function st(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var ut = function ut(t) {
    if (at[t]) return at[t];
    var e = t.split("."),
      n = e[0],
      r = e[1];
    if (!r) throw new Error("Invalid token");
    var i = function (t) {
        try {
          return JSON.parse(ot.decode(t));
        } catch (t) {
          throw new Error("Invalid token");
        }
      }(r),
      o = {
        usage: n,
        user: i.u
      };
    return st(i, "a") && (o.authorization = i.a), st(i, "exp") && (o.expires = 1e3 * i.exp), st(i, "iat") && (o.created = 1e3 * i.iat), st(i, "scopes") && (o.scopes = i.scopes), st(i, "client") && (o.client = i.client), st(i, "ll") && (o.lastLogin = i.ll), st(i, "iu") && (o.impersonator = i.iu), at[t] = o, o;
  },
  ct = o(function (t) {
    var e = Object.prototype.hasOwnProperty,
      n = "~";
    function r() {}
    function i(t, e, n) {
      this.fn = t, this.context = e, this.once = n || !1;
    }
    function o(t, e, r, o, a) {
      if ("function" != typeof r) throw new TypeError("The listener must be a function");
      var s = new i(r, o || t, a),
        u = n ? n + e : e;
      return t._events[u] ? t._events[u].fn ? t._events[u] = [t._events[u], s] : t._events[u].push(s) : (t._events[u] = s, t._eventsCount++), t;
    }
    function a(t, e) {
      0 == --t._eventsCount ? t._events = new r() : delete t._events[e];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    Object.create && (r.prototype = Object.create(null), new r().__proto__ || (n = !1)), s.prototype.eventNames = function () {
      var t,
        r,
        i = [];
      if (0 === this._eventsCount) return i;
      for (r in t = this._events) {
        e.call(t, r) && i.push(n ? r.slice(1) : r);
      }
      return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(t)) : i;
    }, s.prototype.listeners = function (t) {
      var e = this._events[n ? n + t : t];
      if (!e) return [];
      if (e.fn) return [e.fn];
      for (var r = 0, i = e.length, o = new Array(i); r < i; r++) {
        o[r] = e[r].fn;
      }
      return o;
    }, s.prototype.listenerCount = function (t) {
      var e = this._events[n ? n + t : t];
      return e ? e.fn ? 1 : e.length : 0;
    }, s.prototype.emit = function (t, e, r, i, o, a) {
      var s = n ? n + t : t;
      if (!this._events[s]) return !1;
      var u,
        c,
        l = this._events[s],
        h = arguments.length;
      if (l.fn) {
        switch (l.once && this.removeListener(t, l.fn, void 0, !0), h) {
          case 1:
            return l.fn.call(l.context), !0;
          case 2:
            return l.fn.call(l.context, e), !0;
          case 3:
            return l.fn.call(l.context, e, r), !0;
          case 4:
            return l.fn.call(l.context, e, r, i), !0;
          case 5:
            return l.fn.call(l.context, e, r, i, o), !0;
          case 6:
            return l.fn.call(l.context, e, r, i, o, a), !0;
        }
        for (c = 1, u = new Array(h - 1); c < h; c++) {
          u[c - 1] = arguments[c];
        }
        l.fn.apply(l.context, u);
      } else {
        var p,
          f = l.length;
        for (c = 0; c < f; c++) {
          switch (l[c].once && this.removeListener(t, l[c].fn, void 0, !0), h) {
            case 1:
              l[c].fn.call(l[c].context);
              break;
            case 2:
              l[c].fn.call(l[c].context, e);
              break;
            case 3:
              l[c].fn.call(l[c].context, e, r);
              break;
            case 4:
              l[c].fn.call(l[c].context, e, r, i);
              break;
            default:
              if (!u) for (p = 1, u = new Array(h - 1); p < h; p++) {
                u[p - 1] = arguments[p];
              }
              l[c].fn.apply(l[c].context, u);
          }
        }
      }
      return !0;
    }, s.prototype.on = function (t, e, n) {
      return o(this, t, e, n, !1);
    }, s.prototype.once = function (t, e, n) {
      return o(this, t, e, n, !0);
    }, s.prototype.removeListener = function (t, e, r, i) {
      var o = n ? n + t : t;
      if (!this._events[o]) return this;
      if (!e) return a(this, o), this;
      var s = this._events[o];
      if (s.fn) s.fn !== e || i && !s.once || r && s.context !== r || a(this, o);else {
        for (var u = 0, c = [], l = s.length; u < l; u++) {
          (s[u].fn !== e || i && !s[u].once || r && s[u].context !== r) && c.push(s[u]);
        }
        c.length ? this._events[o] = 1 === c.length ? c[0] : c : a(this, o);
      }
      return this;
    }, s.prototype.removeAllListeners = function (t) {
      var e;
      return t ? this._events[e = n ? n + t : t] && a(this, e) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, t.exports = s;
  });
function lt(t) {
  return Array.isArray(t) ? t.map(encodeURIComponent).join(",") : encodeURIComponent(String(t));
}
function ht(t, e, n) {
  if (!1 === n || null === n) return t;
  var r = /\?/.test(t) ? "&" : "?",
    i = encodeURIComponent(e);
  return void 0 !== n && "" !== n && !0 !== n && (i += "=" + lt(n)), "" + t + r + i;
}
var pt = {
    appendQueryObject: function appendQueryObject(t, e) {
      if (!e) return t;
      var n = t;
      return Object.keys(e).forEach(function (t) {
        var r = e[t];
        void 0 !== r && (Array.isArray(r) && (r = r.filter(function (t) {
          return !!t;
        }).join(",")), n = ht(n, t, r));
      }), n;
    },
    appendQueryParam: ht,
    prependOrigin: function prependOrigin(t, e) {
      if (!e) return t;
      if ("http" === t.slice(0, 4)) return t;
      var n = "/" === t[0] ? "" : "/";
      return "" + e.replace(/\/$/, "") + n + t;
    },
    interpolateRouteParams: function interpolateRouteParams(t, e) {
      return e ? t.replace(/\/:([a-zA-Z0-9]+)/g, function (t, n) {
        var r = e[n];
        if (void 0 === r) throw new Error("Unspecified route parameter " + n);
        return "/" + lt(r);
      }) : t;
    }
  },
  ft = 1;
function dt(t, e) {
  if (!t) throw new Error("MapiRequest requires a client");
  if (!e || !e.path || !e.method) throw new Error("MapiRequest requires an options object with path and method properties");
  var n = {};
  e.body && (n["content-type"] = "application/json");
  var r = P(n, e.headers),
    i = Object.keys(r).reduce(function (t, e) {
      return t[e.toLowerCase()] = r[e], t;
    }, {});
  this.id = ft++, this._options = e, this.emitter = new ct(), this.client = t, this.response = null, this.error = null, this.sent = !1, this.aborted = !1, this.path = e.path, this.method = e.method, this.origin = e.origin || t.origin, this.query = e.query || {}, this.params = e.params || {}, this.body = e.body || null, this.file = e.file || null, this.headers = i;
}
dt.prototype.url = function (t) {
  var e = pt.prependOrigin(this.path, this.origin);
  e = pt.appendQueryObject(e, this.query);
  var n = this.params;
  if (t) {
    e = pt.appendQueryParam(e, "access_token", t);
    var r = ut(t).user;
    n = P({
      ownerId: r
    }, n);
  }
  return pt.interpolateRouteParams(e, n);
}, dt.prototype.send = function () {
  var t = this;
  if (t.sent) throw new Error("This request has already been sent. Check the response and error properties. Create a new request with clone().");
  return t.sent = !0, t.client.sendRequest(t).then(function (e) {
    return t.response = e, t.emitter.emit(et.EVENT_RESPONSE, e), e;
  }, function (e) {
    throw t.error = e, t.emitter.emit(et.EVENT_ERROR, e), e;
  });
}, dt.prototype.abort = function () {
  this._nextPageRequest && (this._nextPageRequest.abort(), delete this._nextPageRequest), this.response || this.error || this.aborted || (this.aborted = !0, this.client.abortRequest(this));
}, dt.prototype.eachPage = function (t) {
  var e = this;
  function n(n) {
    t(null, n, function () {
      delete e._nextPageRequest;
      var t = n.nextPage();
      t && (e._nextPageRequest = t, i(t));
    });
  }
  function r(e) {
    t(e, null, function () {});
  }
  function i(t) {
    t.send().then(n, r);
  }
  i(this);
}, dt.prototype.clone = function () {
  return this._extend();
}, dt.prototype._extend = function (t) {
  var e = P(this._options, t);
  return new dt(this.client, e);
};
var yt = dt;
function gt(t) {
  if (!t || !t.accessToken) throw new Error("Cannot create a client without an access token");
  ut(t.accessToken), this.accessToken = t.accessToken, this.origin = t.origin || et.API_ORIGIN;
}
gt.prototype.createRequest = function (t) {
  return new yt(this, t);
};
var mt = gt;
function vt(t) {
  mt.call(this, t);
}
(vt.prototype = Object.create(mt.prototype)).constructor = vt, vt.prototype.sendRequest = function (t) {
  return Promise.resolve().then(function () {
    var e = function (t, e) {
      var n = t.url(e),
        r = new window.XMLHttpRequest();
      return r.open(t.method, n), Object.keys(t.headers).forEach(function (e) {
        r.setRequestHeader(e, t.headers[e]);
      }), r;
    }(t, t.client.accessToken);
    return function (t, e) {
      return new Promise(function (n, r) {
        e.onprogress = function (e) {
          t.emitter.emit(et.EVENT_PROGRESS_DOWNLOAD, it(e));
        };
        var i = t.file;
        i && (e.upload.onprogress = function (e) {
          t.emitter.emit(et.EVENT_PROGRESS_UPLOAD, it(e));
        }), e.onerror = function (t) {
          r(t);
        }, e.onabort = function () {
          var e = new nt({
            request: t,
            type: et.ERROR_REQUEST_ABORTED
          });
          r(e);
        }, e.onload = function () {
          if (delete rt[t.id], e.status < 200 || e.status >= 400) {
            var i = new nt({
              request: t,
              body: e.response,
              statusCode: e.status
            });
            r(i);
          } else n(e);
        };
        var o = t.body;
        "string" == typeof o ? e.send(o) : o ? e.send(JSON.stringify(o)) : i ? e.send(i) : e.send(), rt[t.id] = e;
      }).then(function (e) {
        return function (t, e) {
          return new tt(t, {
            body: e.response,
            headers: (n = e.getAllResponseHeaders(), r = {}, n ? (n.trim().split(/[\r|\n]+/).forEach(function (t) {
              var e = function (t) {
                var e = t.indexOf(":");
                return {
                  name: t.substring(0, e).trim().toLowerCase(),
                  value: t.substring(e + 1).trim()
                };
              }(t);
              r[e.name] = e.value;
            }), r) : r),
            statusCode: e.status
          });
          var n, r;
        }(t, e);
      });
    }(t, e);
  });
}, vt.prototype.abortRequest = function (t) {
  var e = rt[t.id];
  e && (e.abort(), delete rt[t.id]);
};
var bt = function bt(t) {
    return new vt(t);
  },
  _t = bt,
  xt = Object.prototype.toString,
  wt = "value",
  Et = {};
function Mt(t) {
  var e = Array.isArray(t);
  return function (n) {
    var r = Ot(Et.plainArray, n);
    if (r) return r;
    if (e && n.length !== t.length) return "an array with " + t.length + " items";
    for (var i = 0; i < n.length; i++) {
      if (r = Ot(e ? t[i] : t, n[i])) return [i].concat(r);
    }
  };
}
function Ot(t, e) {
  if (null != e || t.hasOwnProperty("__required")) {
    var n = t(e);
    return n ? Array.isArray(n) ? n : [n] : void 0;
  }
}
function jt(t, e) {
  var n = t.length,
    r = t[n - 1],
    i = t.slice(0, n - 1);
  return 0 === i.length && (i = [wt]), e = P(e, {
    path: i
  }), "function" == typeof r ? r(e) : St(e, function (t) {
    return "must be " + (/^an? /.test(e = t) ? e : /^[aeiou]/i.test(e) ? "an " + e : /^[a-z]/i.test(e) ? "a " + e : e) + ".";
    var e;
  }(r));
}
function Pt(t) {
  return t.length < 2 ? t[0] : 2 === t.length ? t.join(" or ") : t.slice(0, -1).join(", ") + ", or " + t.slice(-1);
}
function St(t, e) {
  return (kt(t.path) ? "Item at position " : "") + t.path.join(".") + " " + e;
}
function kt(t) {
  return "number" == typeof t[t.length - 1] || "number" == typeof t[0];
}
Et.assert = function (t, e) {
  return e = e || {}, function (n) {
    var r = Ot(t, n);
    if (r) {
      var i = jt(r, e);
      throw e.apiName && (i = e.apiName + ": " + i), new Error(i);
    }
  };
}, Et.shape = function (t) {
  var e,
    n = (e = t, Object.keys(e || {}).map(function (t) {
      return {
        key: t,
        value: e[t]
      };
    }));
  return function (t) {
    var e,
      r = Ot(Et.plainObject, t);
    if (r) return r;
    for (var i = [], o = 0; o < n.length; o++) {
      (r = Ot(n[o].value, t[e = n[o].key])) && i.push([e].concat(r));
    }
    return i.length < 2 ? i[0] : function (t) {
      i = i.map(function (e) {
        return "- " + e[0] + ": " + jt(e, t).split("\n").join("\n  ");
      });
      var e = t.path.join(".");
      return "The following properties" + (e === wt ? "" : " of " + e) + " have invalid values:\n  " + i.join("\n  ");
    };
  };
}, Et.strictShape = function (t) {
  var e = Et.shape(t);
  return function (n) {
    var r = e(n);
    if (r) return r;
    var i = Object.keys(n).reduce(function (e, n) {
      return void 0 === t[n] && e.push(n), e;
    }, []);
    return 0 !== i.length ? function () {
      return "The following keys are invalid: " + i.join(", ");
    } : void 0;
  };
}, Et.arrayOf = function (t) {
  return Mt(t);
}, Et.tuple = function () {
  var t = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return Mt(t);
}, Et.required = function (t) {
  function e(e) {
    return null == e ? function (t) {
      return St(t, kt(t.path) ? "cannot be undefined/null." : "is required.");
    } : t.apply(this, arguments);
  }
  return e.__required = !0, e;
}, Et.oneOfType = function () {
  var t = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return function (e) {
    var n = t.map(function (t) {
      return Ot(t, e);
    }).filter(Boolean);
    if (n.length === t.length) return n.every(function (t) {
      return 1 === t.length && "string" == typeof t[0];
    }) ? Pt(n.map(function (t) {
      return t[0];
    })) : n.reduce(function (t, e) {
      return e.length > t.length ? e : t;
    });
  };
}, Et.equal = function (t) {
  return function (e) {
    if (e !== t) return JSON.stringify(t);
  };
}, Et.oneOf = function () {
  var t = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments),
    e = t.map(function (t) {
      return Et.equal(t);
    });
  return Et.oneOfType.apply(this, e);
}, Et.range = function (t) {
  var e = t[0],
    n = t[1];
  return function (t) {
    if (Ot(Et.number, t) || t < e || t > n) return "number between " + e + " & " + n + " (inclusive)";
  };
}, Et.any = function () {}, Et.boolean = function (t) {
  if ("boolean" != typeof t) return "boolean";
}, Et.number = function (t) {
  if ("number" != typeof t) return "number";
}, Et.plainArray = function (t) {
  if (!Array.isArray(t)) return "array";
}, Et.plainObject = function (t) {
  if ("[object Object]" !== xt.call(e = t) || null !== (n = Object.getPrototypeOf(e)) && n !== Object.getPrototypeOf({})) return "object";
  var e, n;
}, Et.string = function (t) {
  if ("string" != typeof t) return "string";
}, Et.func = function (t) {
  if ("function" != typeof t) return "function";
}, Et.validate = Ot, Et.processMessage = jt;
var Rt = Et,
  Ct = P(Rt, {
    file: function file(t) {
      if ("undefined" != typeof window) {
        if (t instanceof r.Blob || t instanceof r.ArrayBuffer) return;
        return "Blob or ArrayBuffer";
      }
      if ("string" != typeof t && void 0 === t.pipe) return "Filename or Readable stream";
    },
    date: function date(t) {
      if ("boolean" == typeof t) return "date";
      try {
        var e = new Date(t);
        if (e.getTime && isNaN(e.getTime())) return "date";
      } catch (t) {
        return "date";
      }
    },
    coordinates: function coordinates(t) {
      return Rt.tuple(Rt.number, Rt.number)(t);
    },
    assertShape: function assertShape(t, e) {
      return Rt.assert(Rt.strictShape(t), e);
    }
  }),
  At = function At(t, e) {
    var n = function n(t, _n) {
      return -1 !== e.indexOf(t) && void 0 !== _n;
    };
    return "function" == typeof e && (n = e), Object.keys(t).filter(function (e) {
      return n(e, t[e]);
    }).reduce(function (e, n) {
      return e[n] = t[n], e;
    }, {});
  },
  Tt = function Tt(t) {
    return function (t, e) {
      return Object.keys(t).reduce(function (e, n) {
        return e[n] = "boolean" == typeof (r = t[n]) ? JSON.stringify(r) : r, e;
        var r;
      }, {});
    }(t);
  },
  It = {},
  Lt = ["country", "region", "postcode", "district", "place", "locality", "neighborhood", "address", "poi", "poi.landmark"];
It.forwardGeocode = function (t) {
  Ct.assertShape({
    query: Ct.required(Ct.string),
    mode: Ct.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: Ct.arrayOf(Ct.string),
    proximity: Ct.coordinates,
    types: Ct.arrayOf(Ct.oneOf(Lt)),
    autocomplete: Ct.boolean,
    bbox: Ct.arrayOf(Ct.number),
    limit: Ct.number,
    language: Ct.arrayOf(Ct.string)
  })(t), t.mode = t.mode || "mapbox.places";
  var e = Tt(P({
    country: t.countries
  }, At(t, ["proximity", "types", "autocomplete", "bbox", "limit", "language"])));
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: At(t, ["mode", "query"]),
    query: e
  });
}, It.reverseGeocode = function (t) {
  Ct.assertShape({
    query: Ct.required(Ct.coordinates),
    mode: Ct.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: Ct.arrayOf(Ct.string),
    types: Ct.arrayOf(Ct.oneOf(Lt)),
    bbox: Ct.arrayOf(Ct.number),
    limit: Ct.number,
    language: Ct.arrayOf(Ct.string),
    reverseMode: Ct.oneOf("distance", "score")
  })(t), t.mode = t.mode || "mapbox.places";
  var e = Tt(P({
    country: t.countries
  }, At(t, ["country", "types", "bbox", "limit", "language", "reverseMode"])));
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: At(t, ["mode", "query"]),
    query: e
  });
};
var Nt,
  qt = (Nt = It, function (t) {
    var e;
    e = mt.prototype.isPrototypeOf(t) ? t : bt(t);
    var n = Object.create(Nt);
    return n.client = e, n;
  });
if ("production" !== process.env.NODE_ENV && ("undefined" == typeof self || !self.crypto && !self.msCrypto)) throw new Error("Your browser does not have secure random generator. If you don’t need unpredictable IDs, you can use nanoid/non-secure.");
var Ft = self.crypto || self.msCrypto;
function zt(t) {
  this.origin = t.origin || "https://api.mapbox.com", this.endpoint = "events/v2", this.access_token = t.accessToken, this.version = "0.2.0", this.sessionID = this.generateSessionID(), this.userAgent = this.getUserAgent(), this.options = t, this.send = this.send.bind(this), this.countries = t.countries ? t.countries.split(",") : null, this.types = t.types ? t.types.split(",") : null, this.bbox = t.bbox ? t.bbox : null, this.language = t.language ? t.language.split(",") : null, this.limit = t.limit ? +t.limit : null, this.locale = navigator.language || null, this.enableEventLogging = this.shouldEnableLogging(t), this.eventQueue = new Array(), this.flushInterval = t.flushInterval || 1e3, this.maxQueueSize = t.maxQueueSize || 100, this.timer = this.flushInterval ? setTimeout(this.flush.bind(this), this.flushInterval) : null, this.lastSentInput = "", this.lastSentIndex = 0;
}
zt.prototype = {
  select: function select(t, e) {
    var n = this.getSelectedIndex(t, e),
      r = this.getEventPayload("search.select", e);
    if (r.resultIndex = n, r.resultPlaceName = t.place_name, r.resultId = t.id, (n !== this.lastSentIndex || r.queryString !== this.lastSentInput) && -1 != n && (this.lastSentIndex = n, this.lastSentInput = r.queryString, r.queryString)) return this.push(r);
  },
  start: function start(t) {
    var e = this.getEventPayload("search.start", t);
    if (e.queryString) return this.push(e);
  },
  keyevent: function keyevent(t, e) {
    if (t.key && !t.metaKey && -1 === [9, 27, 37, 39, 13, 38, 40].indexOf(t.keyCode)) {
      var n = this.getEventPayload("search.keystroke", e);
      if (n.lastAction = t.key, n.queryString) return this.push(n);
    }
  },
  send: function send(t, e) {
    if (!this.enableEventLogging) return e ? e() : void 0;
    var n = this.getRequestOptions(t);
    this.request(n, function (t) {
      return t ? this.handleError(t, e) : e ? e() : void 0;
    }.bind(this));
  },
  getRequestOptions: function getRequestOptions(t) {
    return Array.isArray(t) || (t = [t]), {
      method: "POST",
      host: this.origin,
      path: this.endpoint + "?access_token=" + this.access_token,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(t)
    };
  },
  getEventPayload: function getEventPayload(t, e) {
    var n;
    n = e.options.proximity ? [e.options.proximity.longitude, e.options.proximity.latitude] : null;
    var r = e._map ? e._map.getZoom() : null,
      i = {
        event: t,
        created: +new Date(),
        sessionIdentifier: this.sessionID,
        country: this.countries,
        userAgent: this.userAgent,
        language: this.language,
        bbox: this.bbox,
        types: this.types,
        endpoint: "mapbox.places",
        proximity: n,
        limit: e.options.limit,
        mapZoom: r,
        keyboardLocale: this.locale
      };
    return i.queryString = "search.select" === t ? e.inputString : "search.select" != t && e._inputEl ? e._inputEl.value : e.inputString, i;
  },
  request: function request(t, e) {
    var n = new XMLHttpRequest();
    for (var r in n.onreadystatechange = function () {
      if (4 == this.readyState) return e(204 == this.status ? null : this.statusText);
    }, n.open(t.method, t.host + "/" + t.path, !0), t.headers) {
      n.setRequestHeader(r, t.headers[r]);
    }
    n.send(t.body);
  },
  handleError: function handleError(t, e) {
    if (e) return e(t);
  },
  generateSessionID: function generateSessionID() {
    return function (t) {
      t = t || 21;
      for (var e = "", n = Ft.getRandomValues(new Uint8Array(t)); 0 < t--;) {
        e += "Uint8ArdomValuesObj012345679BCDEFGHIJKLMNPQRSTWXYZ_cfghkpqvwxyz-"[63 & n[t]];
      }
      return e;
    }();
  },
  getUserAgent: function getUserAgent() {
    return "mapbox-gl-geocoder." + this.version + "." + navigator.userAgent;
  },
  getSelectedIndex: function getSelectedIndex(t, e) {
    if (e._typeahead) {
      var n = t.id;
      return e._typeahead.data.map(function (t) {
        return t.id;
      }).indexOf(n);
    }
  },
  shouldEnableLogging: function shouldEnableLogging(t) {
    return !(!1 === t.enableEventLogging || t.origin && -1 == t.origin.indexOf("api.mapbox.com") || t.localGeocoder || t.filter);
  },
  flush: function flush() {
    this.eventQueue.length > 0 && (this.send(this.eventQueue), this.eventQueue = new Array()), this.timer && clearTimeout(this.timer), this.flushInterval && (this.timer = setTimeout(this.flush.bind(this), this.flushInterval));
  },
  push: function push(t, e) {
    this.eventQueue.push(t), (this.eventQueue.length >= this.maxQueueSize || e) && this.flush();
  },
  remove: function remove() {
    this.flush();
  }
};
var Bt = zt,
  Vt = {
    placeholder: {
      de: "Suche",
      it: "Ricerca",
      en: "Search",
      nl: "Zoeken",
      fr: "Chercher",
      ca: "Cerca",
      he: "לחפש",
      ja: "サーチ",
      lv: "Meklēt",
      pt: "Procurar",
      sr: "Претрага",
      zh: "搜索",
      cs: "Vyhledávání",
      hu: "Keresés",
      ka: "ძიება",
      nb: "Søke",
      sk: "Vyhľadávanie",
      th: "ค้นหา",
      fi: "Hae",
      is: "Leita",
      ko: "수색",
      pl: "Szukaj",
      sl: "Iskanje"
    }
  },
  Dt = o(function (t) {
    !function (e, n, r) {
      t.exports ? t.exports = r() : e.subtag = r();
    }(r, 0, function () {
      var t = "",
        e = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
      function n(t) {
        return t.match(e) || [];
      }
      function r(e) {
        return {
          language: (e = n(e))[1] || t,
          extlang: e[2] || t,
          script: e[3] || t,
          region: e[4] || t
        };
      }
      function i(t, e, n) {
        Object.defineProperty(t, e, {
          value: n,
          enumerable: !0
        });
      }
      function o(e, o, a) {
        function s(r) {
          return n(r)[e] || t;
        }
        i(s, "pattern", o), i(r, a, s);
      }
      return o(1, /^[a-zA-Z]{2,3}$/, "language"), o(2, /^[a-zA-Z]{3}$/, "extlang"), o(3, /^[a-zA-Z]{4}$/, "script"), o(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, "region"), i(r, "split", function (t) {
        return n(t).filter(function (t, e) {
          return t && e;
        });
      }), r;
    });
  }),
  $t = e.EventEmitter;
function Gt(t) {
  this._eventEmitter = new $t(), this.options = P({}, this.options, t), this.inputString = "", this.fresh = !0, this.lastSelected = null;
}
Gt.prototype = {
  options: {
    zoom: 16,
    flyTo: !0,
    trackProximity: !0,
    minLength: 2,
    reverseGeocode: !1,
    limit: 5,
    origin: "https://api.mapbox.com",
    enableEventLogging: !0,
    marker: !0,
    mapboxgl: null,
    collapsed: !1,
    clearAndBlurOnEsc: !1,
    clearOnBlur: !1,
    getItemValue: function getItemValue(t) {
      return t.place_name;
    },
    render: function render(t) {
      var e = t.place_name.split(",");
      return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title">' + e[0] + '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">' + e.splice(1, e.length).join(",") + "</div></div>";
    }
  },
  onAdd: function onAdd(t) {
    this._map = t, this.setLanguage(), this.geocoderService = qt(_t({
      accessToken: this.options.accessToken,
      origin: this.options.origin
    })), this.eventManager = new Bt(this.options), this._onChange = this._onChange.bind(this), this._onKeyDown = this._onKeyDown.bind(this), this._onBlur = this._onBlur.bind(this), this._showButton = this._showButton.bind(this), this._hideButton = this._hideButton.bind(this), this._onQueryResult = this._onQueryResult.bind(this), this.clear = this.clear.bind(this), this._updateProximity = this._updateProximity.bind(this), this._collapse = this._collapse.bind(this), this._unCollapse = this._unCollapse.bind(this), this._clear = this._clear.bind(this), this._clearOnBlur = this._clearOnBlur.bind(this);
    var e = this.container = document.createElement("div");
    e.className = "mapboxgl-ctrl-geocoder mapboxgl-ctrl";
    var n = this.createIcon("search", '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>');
    this._inputEl = document.createElement("input"), this._inputEl.type = "text", this._inputEl.className = "mapboxgl-ctrl-geocoder--input", this.setPlaceholder(), this.options.collapsed && (this._collapse(), this.container.addEventListener("mouseenter", this._unCollapse), this.container.addEventListener("mouseleave", this._collapse), this._inputEl.addEventListener("focus", this._unCollapse)), (this.options.collapsed || this.options.clearOnBlur) && this._inputEl.addEventListener("blur", this._onBlur), this._inputEl.addEventListener("keydown", function (t, e, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        c = 0,
        l = !1,
        h = !1,
        p = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      function f(e) {
        var n = r,
          o = i;
        return r = i = void 0, c = e, a = t.apply(o, n);
      }
      function d(t) {
        var n = t - u;
        return void 0 === u || n >= e || n < 0 || h && t - c >= o;
      }
      function y() {
        var t = H();
        if (d(t)) return g(t);
        s = setTimeout(y, function (t) {
          var n = e - (t - u);
          return h ? Q(n, o - (t - c)) : n;
        }(t));
      }
      function g(t) {
        return s = void 0, p && r ? f(t) : (r = i = void 0, a);
      }
      function m() {
        var t = H(),
          n = d(t);
        if (r = arguments, i = this, u = t, n) {
          if (void 0 === s) return function (t) {
            return c = t, s = setTimeout(y, e), l ? f(t) : a;
          }(u);
          if (h) return s = setTimeout(y, e), f(u);
        }
        return void 0 === s && (s = setTimeout(y, e)), a;
      }
      return e = K(e) || 0, W(void 0) && (l = !!(void 0).leading, o = (h = "maxWait" in void 0) ? Z(K((void 0).maxWait) || 0, e) : o, p = "trailing" in void 0 ? !!(void 0).trailing : p), m.cancel = function () {
        void 0 !== s && clearTimeout(s), c = 0, r = u = i = s = void 0;
      }, m.flush = function () {
        return void 0 === s ? a : g(H());
      }, m;
    }(this._onKeyDown, 200)), this._inputEl.addEventListener("change", this._onChange), this.container.addEventListener("mouseenter", this._showButton), this.container.addEventListener("mouseleave", this._hideButton), this._inputEl.addEventListener("keyup", function (t) {
      this.eventManager.keyevent(t, this);
    }.bind(this));
    var r = document.createElement("div");
    r.classList.add("mapboxgl-ctrl-geocoder--pin-right"), this._clearEl = document.createElement("button"), this._clearEl.setAttribute("aria-label", "Clear"), this._clearEl.addEventListener("click", this.clear), this._clearEl.className = "mapboxgl-ctrl-geocoder--button";
    var i = this.createIcon("close", '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>');
    return this._clearEl.appendChild(i), this._loadingEl = this.createIcon("loading", '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>'), r.appendChild(this._clearEl), r.appendChild(this._loadingEl), e.appendChild(n), e.appendChild(this._inputEl), e.appendChild(r), this._typeahead = new I(this._inputEl, [], {
      filter: !1,
      minLength: this.options.minLength,
      limit: this.options.limit
    }), this.setRenderFunction(this.options.render), this._typeahead.getItemValue = this.options.getItemValue, this.options.trackProximity && (this._updateProximity(), this._map.on("moveend", this._updateProximity)), this.mapMarker = null, this._handleMarker = this._handleMarker.bind(this), this._mapboxgl = this.options.mapboxgl, !this._mapboxgl && this.options.marker && (console.error("No mapboxgl detected in options. Map markers are disabled. Please set options.mapboxgl."), this.options.marker = !1), e;
  },
  createIcon: function createIcon(t, e) {
    var n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    return n.setAttribute("class", "mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-" + t), n.setAttribute("viewBox", "0 0 18 18"), n.setAttribute("xml:space", "preserve"), n.setAttribute("width", 18), n.setAttribute("height", 18), n.innerHTML = e, n;
  },
  onRemove: function onRemove() {
    return this.container.parentNode.removeChild(this.container), this.options.trackProximity && this._map.off("moveend", this._updateProximity), this._removeMarker(), this._map = null, this;
  },
  _onKeyDown: function _onKeyDown(t) {
    var e = 27,
      n = 9;
    if (t.keyCode === e && this.options.clearAndBlurOnEsc) return this._clear(t), this._inputEl.blur();
    var r = t.target && t.target.shadowRoot ? t.target.shadowRoot.activeElement : t.target;
    if (!r || !r.value) return this.fresh = !0, t.keyCode !== n && this.clear(t), this._clearEl.style.display = "none";
    t.metaKey || -1 !== [n, e, 37, 39, 13, 38, 40].indexOf(t.keyCode) || r.value.length >= this.options.minLength && this._geocode(r.value);
  },
  _showButton: function _showButton() {
    this._typeahead.selected && (this._clearEl.style.display = "block");
  },
  _hideButton: function _hideButton() {
    this._typeahead.selected && (this._clearEl.style.display = "none");
  },
  _onBlur: function _onBlur(t) {
    this.options.clearOnBlur && this._clearOnBlur(t), this.options.collapsed && this._collapse();
  },
  _onChange: function _onChange() {
    var t = this._typeahead.selected;
    if (t && t.id !== this.lastSelected) {
      var e;
      if (this._clearEl.style.display = "none", this.options.flyTo) if (t.properties && !J[t.properties.short_code] && t.bbox) {
        var n = t.bbox;
        e = P({}, this.options.flyTo), this._map.fitBounds([[n[0], n[1]], [n[2], n[3]]], e);
      } else t.properties && J[t.properties.short_code] ? (e = P({}, this.options.flyTo), this._map.fitBounds(J[t.properties.short_code].bbox, e)) : ((e = P({}, {
        zoom: this.options.zoom
      }, this.options.flyTo)).center = t.center, this._map.flyTo(e));
      this.options.marker && this._mapboxgl && this._handleMarker(t), this._inputEl.focus(), this._inputEl.scrollLeft = 0, this._inputEl.setSelectionRange(0, 0), this._eventEmitter.emit("result", {
        result: t
      }), this.eventManager.select(t, this), this.lastSelected = t.id;
    }
  },
  _geocode: function _geocode(t) {
    this._loadingEl.style.display = "block", this._eventEmitter.emit("loading", {
      query: t
    }), this.inputString = t;
    var e,
      n = this,
      r = ["bbox", "limit", "proximity", "countries", "types", "language", "reverseMode"].reduce(function (t, e) {
        return n.options[e] && (t[e] = ["countries", "types", "language"].indexOf(e) > -1 ? n.options[e].split(/[\s,]+/) : n.options[e], "proximity" === e && n.options[e] && n.options[e].longitude && n.options[e].latitude && (t[e] = [n.options[e].longitude, n.options[e].latitude])), t;
      }, {});
    if (this.options.reverseGeocode && /(-?\d+\.?\d*)[, ]+(-?\d+\.?\d*)[ ]*$/.test(t)) {
      var i = t.split(/[\s(,)?]+/).map(function (t) {
        return parseFloat(t, 10);
      }).reverse();
      r = P(r, {
        query: i,
        limit: 1
      }), e = this.geocoderService.reverseGeocode(r).send();
    } else r = P(r, {
      query: t
    }), e = this.geocoderService.forwardGeocode(r).send();
    var o = [];
    return this.options.localGeocoder && ((o = this.options.localGeocoder(t)) || (o = [])), e.then(function (t) {
      this._loadingEl.style.display = "none";
      var e = {};
      "200" == t.statusCode && (e = t.body), e.config = r, this.fresh && (this.eventManager.start(this), this.fresh = !1), e.features = e.features ? o.concat(e.features) : o, this.options.filter && e.features.length && (e.features = e.features.filter(this.options.filter)), e.features.length ? (this._clearEl.style.display = "block", this._eventEmitter.emit("results", e), this._typeahead.update(e.features)) : (this._clearEl.style.display = "none", this._typeahead.selected = null, this._renderNoResults(), this._eventEmitter.emit("results", e));
    }.bind(this)), e.catch(function (t) {
      this._loadingEl.style.display = "none", o.length && this.options.localGeocoder ? (this._clearEl.style.display = "block", this._typeahead.update(o)) : (this._clearEl.style.display = "none", this._typeahead.selected = null, this._renderError()), this._eventEmitter.emit("results", {
        features: o
      }), this._eventEmitter.emit("error", {
        error: t
      });
    }.bind(this)), e;
  },
  _clear: function _clear(t) {
    t && t.preventDefault(), this._inputEl.value = "", this._typeahead.selected = null, this._typeahead.clear(), this._onChange(), this._clearEl.style.display = "none", this._removeMarker(), this.lastSelected = null, this._eventEmitter.emit("clear"), this.fresh = !0;
  },
  clear: function clear(t) {
    this._clear(t), this._inputEl.focus();
  },
  _clearOnBlur: function _clearOnBlur(t) {
    t.relatedTarget && this._clear(t);
  },
  _onQueryResult: function _onQueryResult(t) {
    var e = t.body;
    if (e.features.length) {
      var n = e.features[0];
      this._typeahead.selected = n, this._inputEl.value = n.place_name, this._onChange();
    }
  },
  _updateProximity: function _updateProximity() {
    if (this._map.getZoom() > 9) {
      var t = this._map.getCenter().wrap();
      this.setProximity({
        longitude: t.lng,
        latitude: t.lat
      });
    } else this.setProximity(null);
  },
  _collapse: function _collapse() {
    this._inputEl.value || this._inputEl === document.activeElement || this.container.classList.add("mapboxgl-ctrl-geocoder--collapsed");
  },
  _unCollapse: function _unCollapse() {
    this.container.classList.remove("mapboxgl-ctrl-geocoder--collapsed");
  },
  query: function query(t) {
    return this._geocode(t).then(this._onQueryResult), this;
  },
  _renderError: function _renderError() {
    this._renderMessage("<div class='mapbox-gl-geocoder--error'>There was an error reaching the server</div>");
  },
  _renderNoResults: function _renderNoResults() {
    this._renderMessage("<div class='mapbox-gl-geocoder--error mapbox-gl-geocoder--no-results'>No results found</div>");
  },
  _renderMessage: function _renderMessage(t) {
    this._typeahead.update([]), this._typeahead.selected = null, this._typeahead.clear(), this._typeahead.renderError(t);
  },
  _getPlaceholderText: function _getPlaceholderText() {
    if (this.options.placeholder) return this.options.placeholder;
    if (this.options.language) {
      var t = this.options.language.split(",")[0],
        e = Dt.language(t),
        n = Vt.placeholder[e];
      if (n) return n;
    }
    return "Search";
  },
  setInput: function setInput(t) {
    return this._inputEl.value = t, this._typeahead.selected = null, this._typeahead.clear(), this._onChange(), this;
  },
  setProximity: function setProximity(t) {
    return this.options.proximity = t, this;
  },
  getProximity: function getProximity() {
    return this.options.proximity;
  },
  setRenderFunction: function setRenderFunction(t) {
    return t && "function" == typeof t && (this._typeahead.render = t), this;
  },
  getRenderFunction: function getRenderFunction() {
    return this._typeahead.render;
  },
  setLanguage: function setLanguage(t) {
    var e = navigator.language || navigator.userLanguage || navigator.browserLanguage;
    return this.options.language = t || this.options.language || e, this;
  },
  getLanguage: function getLanguage() {
    return this.options.language;
  },
  getZoom: function getZoom() {
    return this.options.zoom;
  },
  setZoom: function setZoom(t) {
    return this.options.zoom = t, this;
  },
  getFlyTo: function getFlyTo() {
    return this.options.flyTo;
  },
  setFlyTo: function setFlyTo(t) {
    return this.options.flyTo = t, this;
  },
  getPlaceholder: function getPlaceholder() {
    return this.options.placeholder;
  },
  setPlaceholder: function setPlaceholder(t) {
    return this.placeholder = t || this._getPlaceholderText(), this._inputEl.placeholder = this.placeholder, this;
  },
  getBbox: function getBbox() {
    return this.options.bbox;
  },
  setBbox: function setBbox(t) {
    return this.options.bbox = t, this;
  },
  getCountries: function getCountries() {
    return this.options.countries;
  },
  setCountries: function setCountries(t) {
    return this.options.countries = t, this;
  },
  getTypes: function getTypes() {
    return this.options.types;
  },
  setTypes: function setTypes(t) {
    return this.options.types = t, this;
  },
  getMinLength: function getMinLength() {
    return this.options.minLength;
  },
  setMinLength: function setMinLength(t) {
    return this.options.minLength = t, this._typeahead && (this._typeahead.minLength = t), this;
  },
  getLimit: function getLimit() {
    return this.options.limit;
  },
  setLimit: function setLimit(t) {
    return this.options.limit = t, this._typeahead && (this._typeahead.options.limit = t), this;
  },
  getFilter: function getFilter() {
    return this.options.filter;
  },
  setFilter: function setFilter(t) {
    return this.options.filter = t, this;
  },
  _handleMarker: function _handleMarker(t) {
    this._removeMarker();
    var e = P({}, {
      color: "#4668F2"
    }, this.options.marker);
    return this.mapMarker = new this._mapboxgl.Marker(e), this.mapMarker.setLngLat(t.center).addTo(this._map), this;
  },
  _removeMarker: function _removeMarker() {
    this.mapMarker && (this.mapMarker.remove(), this.mapMarker = null);
  },
  on: function on(t, e) {
    return this._eventEmitter.on(t, e), this;
  },
  off: function off(t, e) {
    return this._eventEmitter.removeListener(t, e), this.eventManager.remove(), this;
  }
};
var Ut = Gt;
function Zt(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Qt(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Ht(t, e, n) {
  return e && Qt(t.prototype, e), n && Qt(t, n), t;
}
function Wt(t) {
  return (Wt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}
function Kt(t) {
  return (Kt = "function" == typeof Symbol && "symbol" === Wt(Symbol.iterator) ? function (t) {
    return Wt(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : Wt(t);
  })(t);
}
function Jt(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Yt(t) {
  return (Yt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function Xt(t, e) {
  return (Xt = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
function te(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = [],
      r = !0,
      i = !1,
      o = void 0;
    try {
      for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0) {
        ;
      }
    } catch (t) {
      i = !0, o = t;
    } finally {
      try {
        r || null == s.return || s.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
var ee,
  ne = 1e-6,
  re = "undefined" != typeof Float32Array ? Float32Array : Array;
function ie(t, e) {
  var n = function (t, n, r) {
    var i = e[0],
      o = e[1],
      a = e[2],
      s = e[3];
    return t[0] = r[0] * i + r[4] * o + r[8] * a + r[12] * s, t[1] = r[1] * i + r[5] * o + r[9] * a + r[13] * s, t[2] = r[2] * i + r[6] * o + r[10] * a + r[14] * s, t[3] = r[3] * i + r[7] * o + r[11] * a + r[15] * s, t;
  }([], 0, t);
  return function (t, e, n) {
    t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n;
  }(n, n, 1 / n[3]), n;
}
function oe(t, e, n) {
  var r = e[0],
    i = e[1],
    o = e[2],
    a = e[3],
    s = e[4],
    u = e[5],
    c = e[6],
    l = e[7],
    h = e[8],
    p = e[9],
    f = e[10],
    d = e[11],
    y = e[12],
    g = e[13],
    m = e[14],
    v = e[15],
    b = n[0],
    _ = n[1],
    x = n[2],
    w = n[3];
  return t[0] = b * r + _ * s + x * h + w * y, t[1] = b * i + _ * u + x * p + w * g, t[2] = b * o + _ * c + x * f + w * m, t[3] = b * a + _ * l + x * d + w * v, t[4] = (b = n[4]) * r + (_ = n[5]) * s + (x = n[6]) * h + (w = n[7]) * y, t[5] = b * i + _ * u + x * p + w * g, t[6] = b * o + _ * c + x * f + w * m, t[7] = b * a + _ * l + x * d + w * v, t[8] = (b = n[8]) * r + (_ = n[9]) * s + (x = n[10]) * h + (w = n[11]) * y, t[9] = b * i + _ * u + x * p + w * g, t[10] = b * o + _ * c + x * f + w * m, t[11] = b * a + _ * l + x * d + w * v, t[12] = (b = n[12]) * r + (_ = n[13]) * s + (x = n[14]) * h + (w = n[15]) * y, t[13] = b * i + _ * u + x * p + w * g, t[14] = b * o + _ * c + x * f + w * m, t[15] = b * a + _ * l + x * d + w * v, t;
}
function ae(t, e, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    h,
    p,
    f,
    d,
    y = n[0],
    g = n[1],
    m = n[2];
  return e === t ? (t[12] = e[0] * y + e[4] * g + e[8] * m + e[12], t[13] = e[1] * y + e[5] * g + e[9] * m + e[13], t[14] = e[2] * y + e[6] * g + e[10] * m + e[14], t[15] = e[3] * y + e[7] * g + e[11] * m + e[15]) : (i = e[1], o = e[2], a = e[3], s = e[4], u = e[5], c = e[6], l = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = r = e[0], t[1] = i, t[2] = o, t[3] = a, t[4] = s, t[5] = u, t[6] = c, t[7] = l, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = r * y + s * g + h * m + e[12], t[13] = i * y + u * g + p * m + e[13], t[14] = o * y + c * g + f * m + e[14], t[15] = a * y + l * g + d * m + e[15]), t;
}
function se(t, e, n) {
  var r = n[0],
    i = n[1],
    o = n[2];
  return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * o, t[9] = e[9] * o, t[10] = e[10] * o, t[11] = e[11] * o, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
}
function ue(t, e) {
  var n = t[0],
    r = t[1],
    i = t[2],
    o = t[3],
    a = t[4],
    s = t[5],
    u = t[6],
    c = t[7],
    l = t[8],
    h = t[9],
    p = t[10],
    f = t[11],
    d = t[12],
    y = t[13],
    g = t[14],
    m = t[15],
    v = e[0],
    b = e[1],
    _ = e[2],
    x = e[3],
    w = e[4],
    E = e[5],
    M = e[6],
    O = e[7],
    j = e[8],
    P = e[9],
    S = e[10],
    k = e[11],
    R = e[12],
    C = e[13],
    A = e[14],
    T = e[15];
  return Math.abs(n - v) <= ne * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(r - b) <= ne * Math.max(1, Math.abs(r), Math.abs(b)) && Math.abs(i - _) <= ne * Math.max(1, Math.abs(i), Math.abs(_)) && Math.abs(o - x) <= ne * Math.max(1, Math.abs(o), Math.abs(x)) && Math.abs(a - w) <= ne * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(s - E) <= ne * Math.max(1, Math.abs(s), Math.abs(E)) && Math.abs(u - M) <= ne * Math.max(1, Math.abs(u), Math.abs(M)) && Math.abs(c - O) <= ne * Math.max(1, Math.abs(c), Math.abs(O)) && Math.abs(l - j) <= ne * Math.max(1, Math.abs(l), Math.abs(j)) && Math.abs(h - P) <= ne * Math.max(1, Math.abs(h), Math.abs(P)) && Math.abs(p - S) <= ne * Math.max(1, Math.abs(p), Math.abs(S)) && Math.abs(f - k) <= ne * Math.max(1, Math.abs(f), Math.abs(k)) && Math.abs(d - R) <= ne * Math.max(1, Math.abs(d), Math.abs(R)) && Math.abs(y - C) <= ne * Math.max(1, Math.abs(y), Math.abs(C)) && Math.abs(g - A) <= ne * Math.max(1, Math.abs(g), Math.abs(A)) && Math.abs(m - T) <= ne * Math.max(1, Math.abs(m), Math.abs(T));
}
function ce(t, e, n) {
  return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t;
}
function le(t, e) {
  if (!t) throw new Error(e || "viewport-mercator-project: assertion failed.");
}
ee = new re(4), re != Float32Array && (ee[0] = 0, ee[1] = 0, ee[2] = 0, ee[3] = 0), function () {
  var t = new re(2);
  re != Float32Array && (t[0] = 0, t[1] = 0);
}(), function () {
  var t = new re(3);
  re != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0);
}();
var he = Math.PI,
  pe = he / 4,
  fe = he / 180,
  de = 180 / he,
  ye = 512,
  ge = 4003e4,
  me = 1.5;
function ve(t) {
  return Math.pow(2, t);
}
function be(t, e) {
  var n = te(t, 2),
    r = n[0],
    i = n[1];
  return le(Number.isFinite(r) && Number.isFinite(e)), le(Number.isFinite(i) && i >= -90 && i <= 90, "invalid latitude"), [(e *= ye) * (r * fe + he) / (2 * he), e * (he - Math.log(Math.tan(pe + i * fe * .5))) / (2 * he)];
}
function _e(t, e) {
  var n = te(t, 2),
    r = n[0] / (e *= ye) * (2 * he) - he,
    i = 2 * (Math.atan(Math.exp(he - n[1] / e * (2 * he))) - pe);
  return [r * de, i * de];
}
function xe(t, e) {
  var n = te(t, 3),
    r = n[0],
    i = n[1],
    o = n[2],
    a = void 0 === o ? 0 : o;
  return le(Number.isFinite(r) && Number.isFinite(i) && Number.isFinite(a)), ie(e, [r, i, a, 1]);
}
function we(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
    r = te(t, 3),
    i = r[0],
    o = r[1],
    a = r[2];
  if (le(Number.isFinite(i) && Number.isFinite(o), "invalid pixel coordinate"), Number.isFinite(a)) return ie(e, [i, o, a, 1]);
  var s = ie(e, [i, o, 0, 1]),
    u = ie(e, [i, o, 1, 1]),
    c = s[2],
    l = u[2];
  return function (t, e, n, r) {
    var i = s[0],
      o = s[1];
    return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t;
  }([], 0, u, c === l ? 0 : ((n || 0) - c) / (l - c));
}
var Ee = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
  Me = function () {
    function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = e.width,
        r = e.height,
        i = e.viewMatrix,
        o = void 0 === i ? Ee : i,
        a = e.projectionMatrix,
        s = void 0 === a ? Ee : a;
      Zt(this, t), this.width = n || 1, this.height = r || 1, this.scale = 1, this.pixelsPerMeter = 1, this.viewMatrix = o, this.projectionMatrix = s;
      var u = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
      oe(u, u, this.projectionMatrix), oe(u, u, this.viewMatrix), this.viewProjectionMatrix = u;
      var c = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
      se(c, c, [this.width / 2, -this.height / 2, 1]), ae(c, c, [1, -1, 0]), oe(c, c, this.viewProjectionMatrix);
      var l = function (t, e) {
        var n = c[0],
          r = c[1],
          i = c[2],
          o = c[3],
          a = c[4],
          s = c[5],
          u = c[6],
          l = c[7],
          h = c[8],
          p = c[9],
          f = c[10],
          d = c[11],
          y = c[12],
          g = c[13],
          m = c[14],
          v = c[15],
          b = n * s - r * a,
          _ = n * u - i * a,
          x = n * l - o * a,
          w = r * u - i * s,
          E = r * l - o * s,
          M = i * l - o * u,
          O = h * g - p * y,
          j = h * m - f * y,
          P = h * v - d * y,
          S = p * m - f * g,
          k = p * v - d * g,
          R = f * v - d * m,
          C = b * R - _ * k + x * S + w * P - E * j + M * O;
        return C ? (t[0] = (s * R - u * k + l * S) * (C = 1 / C), t[1] = (i * k - r * R - o * S) * C, t[2] = (g * M - m * E + v * w) * C, t[3] = (f * E - p * M - d * w) * C, t[4] = (u * P - a * R - l * j) * C, t[5] = (n * R - i * P + o * j) * C, t[6] = (m * x - y * M - v * _) * C, t[7] = (h * M - f * x + d * _) * C, t[8] = (a * k - s * P + l * O) * C, t[9] = (r * P - n * k - o * O) * C, t[10] = (y * E - g * x + v * b) * C, t[11] = (p * x - h * E - d * b) * C, t[12] = (s * j - a * S - u * O) * C, t[13] = (n * S - r * j + i * O) * C, t[14] = (g * _ - y * w - m * b) * C, t[15] = (h * w - p * _ + f * b) * C, t) : null;
      }([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
      if (!l) throw new Error("Pixel project matrix not invertible");
      this.pixelProjectionMatrix = c, this.pixelUnprojectionMatrix = l, this.equals = this.equals.bind(this), this.project = this.project.bind(this), this.unproject = this.unproject.bind(this), this.projectPosition = this.projectPosition.bind(this), this.unprojectPosition = this.unprojectPosition.bind(this), this.projectFlat = this.projectFlat.bind(this), this.unprojectFlat = this.unprojectFlat.bind(this);
    }
    return Ht(t, [{
      key: "equals",
      value: function value(e) {
        return e instanceof t && e.width === this.width && e.height === this.height && ue(e.projectionMatrix, this.projectionMatrix) && ue(e.viewMatrix, this.viewMatrix);
      }
    }, {
      key: "project",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = e.topLeft,
          r = void 0 === n || n,
          i = this.projectPosition(t),
          o = xe(i, this.pixelProjectionMatrix),
          a = te(o, 2),
          s = a[0],
          u = a[1],
          c = r ? u : this.height - u;
        return 2 === t.length ? [s, c] : [s, c, o[2]];
      }
    }, {
      key: "unproject",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = e.topLeft,
          r = void 0 === n || n,
          i = e.targetZ,
          o = te(t, 3),
          a = o[0],
          s = o[1],
          u = o[2],
          c = r ? s : this.height - s,
          l = i && i * this.pixelsPerMeter,
          h = we([a, c, u], this.pixelUnprojectionMatrix, l),
          p = this.unprojectPosition(h),
          f = te(p, 3),
          d = f[0],
          y = f[1],
          g = f[2];
        return Number.isFinite(u) ? [d, y, g] : Number.isFinite(i) ? [d, y, i] : [d, y];
      }
    }, {
      key: "projectPosition",
      value: function value(t) {
        var e = te(this.projectFlat(t), 2);
        return [e[0], e[1], (t[2] || 0) * this.pixelsPerMeter];
      }
    }, {
      key: "unprojectPosition",
      value: function value(t) {
        var e = te(this.unprojectFlat(t), 2);
        return [e[0], e[1], (t[2] || 0) / this.pixelsPerMeter];
      }
    }, {
      key: "projectFlat",
      value: function value(t) {
        return t;
      }
    }, {
      key: "unprojectFlat",
      value: function value(t) {
        return t;
      }
    }]), t;
  }();
function Oe(t) {
  var e = t.width,
    n = t.height,
    r = t.padding,
    i = void 0 === r ? 0 : r,
    o = t.offset,
    a = void 0 === o ? [0, 0] : o,
    s = te(t.bounds, 2),
    u = te(s[0], 2),
    c = u[0],
    l = u[1],
    h = te(s[1], 2),
    p = h[0],
    f = h[1];
  Number.isFinite(i) ? i = {
    top: i,
    bottom: i,
    left: i,
    right: i
  } : le(Number.isFinite(i.top) && Number.isFinite(i.bottom) && Number.isFinite(i.left) && Number.isFinite(i.right));
  var d = new je({
      width: e,
      height: n,
      longitude: 0,
      latitude: 0,
      zoom: 0
    }),
    y = d.project([c, f]),
    g = d.project([p, l]),
    m = [Math.abs(g[0] - y[0]), Math.abs(g[1] - y[1])],
    v = [e - i.left - i.right - 2 * Math.abs(a[0]), n - i.top - i.bottom - 2 * Math.abs(a[1])];
  le(v[0] > 0 && v[1] > 0);
  var b = v[0] / m[0],
    _ = v[1] / m[1],
    x = d.unproject([(g[0] + y[0]) / 2 + (i.right - i.left) / 2 / b, (g[1] + y[1]) / 2 + (i.bottom - i.top) / 2 / _]),
    w = d.zoom + Math.log2(Math.abs(Math.min(b, _)));
  return {
    longitude: x[0],
    latitude: x[1],
    zoom: w
  };
}
var je = function (t) {
    function e() {
      var t,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        r = n.width,
        i = n.height,
        o = n.latitude,
        a = void 0 === o ? 0 : o,
        s = n.longitude,
        u = void 0 === s ? 0 : s,
        c = n.zoom,
        l = void 0 === c ? 0 : c,
        h = n.pitch,
        p = void 0 === h ? 0 : h,
        f = n.bearing,
        d = void 0 === f ? 0 : f,
        y = n.altitude,
        g = void 0 === y ? 1.5 : y,
        m = n.nearZMultiplier,
        v = n.farZMultiplier;
      Zt(this, e), r = r || 1, i = i || 1;
      var b = ve(l);
      g = Math.max(.75, g);
      var _ = be([u, a], b);
      _[2] = 0;
      var x,
        w,
        E = function (t, e, n, r, i) {
          var o,
            a = 1 / Math.tan(w.fov / 2);
          return t[0] = a / n, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && Infinity !== i ? (t[10] = (i + r) * (o = 1 / (r - i)), t[14] = 2 * i * r * o) : (t[10] = -1, t[14] = -2 * r), t;
        }([], 0, (w = function (t) {
          var e = t.width,
            n = t.height,
            r = t.altitude,
            i = void 0 === r ? me : r,
            o = t.pitch,
            a = t.nearZMultiplier,
            s = void 0 === a ? 1 : a,
            u = t.farZMultiplier,
            c = void 0 === u ? 1 : u,
            l = (void 0 === o ? 0 : o) * fe,
            h = Math.atan(.5 / i),
            p = Math.sin(h) * i / Math.sin(Math.PI / 2 - l - h),
            f = Math.cos(Math.PI / 2 - l) * p + i;
          return {
            fov: 2 * Math.atan(n / 2 / i),
            aspect: e / n,
            focalDistance: i,
            near: s,
            far: f * c
          };
        }({
          width: (x = {
            width: r,
            height: i,
            pitch: p,
            bearing: d,
            altitude: g,
            nearZMultiplier: m || 1 / i,
            farZMultiplier: v || 1.01
          }).width,
          height: x.height,
          altitude: x.altitude,
          pitch: x.pitch,
          nearZMultiplier: x.nearZMultiplier,
          farZMultiplier: x.farZMultiplier
        })).aspect, w.near, w.far),
        M = function (t) {
          var e = t.height,
            n = t.pitch,
            r = t.bearing,
            i = t.center,
            o = void 0 === i ? null : i,
            a = t.flipY,
            s = void 0 !== a && a,
            u = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          return ae(u, u, [0, 0, -t.altitude]), se(u, u, [1, 1, 1 / e]), function (t, e, n) {
            var r = Math.sin(n),
              i = Math.cos(n),
              o = e[4],
              a = e[5],
              s = e[6],
              u = e[7],
              c = e[8],
              l = e[9],
              h = e[10],
              p = e[11];
            e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = o * i + c * r, t[5] = a * i + l * r, t[6] = s * i + h * r, t[7] = u * i + p * r, t[8] = c * i - o * r, t[9] = l * i - a * r, t[10] = h * i - s * r, t[11] = p * i - u * r;
          }(u, u, -n * fe), function (t, e, n) {
            var r = Math.sin(n),
              i = Math.cos(n),
              o = e[0],
              a = e[1],
              s = e[2],
              u = e[3],
              c = e[4],
              l = e[5],
              h = e[6],
              p = e[7];
            e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = o * i + c * r, t[1] = a * i + l * r, t[2] = s * i + h * r, t[3] = u * i + p * r, t[4] = c * i - o * r, t[5] = l * i - a * r, t[6] = h * i - s * r, t[7] = p * i - u * r;
          }(u, u, r * fe), s && se(u, u, [1, -1, 1]), o && ae(u, u, function (t, e) {
            return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
          }([], o)), u;
        }({
          height: i,
          center: _,
          pitch: p,
          bearing: d,
          altitude: g,
          flipY: !0
        });
      return (t = function (t, e) {
        return !e || "object" !== Kt(e) && "function" != typeof e ? Jt(t) : e;
      }(this, Yt(e).call(this, {
        width: r,
        height: i,
        viewMatrix: M,
        projectionMatrix: E
      }))).latitude = a, t.longitude = u, t.zoom = l, t.pitch = p, t.bearing = d, t.altitude = g, t.scale = b, t.center = _, t.pixelsPerMeter = function (t) {
        var e = t.latitude,
          n = t.longitude,
          r = t.scale,
          i = t.highPrecision,
          o = void 0 !== i && i;
        r = void 0 !== r ? r : ve(t.zoom), le(Number.isFinite(e) && Number.isFinite(n) && Number.isFinite(r));
        var a = {},
          s = ye * r,
          u = Math.cos(e * fe),
          c = s / 360,
          l = c / u,
          h = s / ge / u;
        if (a.pixelsPerMeter = [h, -h, h], a.metersPerPixel = [1 / h, -1 / h, 1 / h], a.pixelsPerDegree = [c, -l, h], a.degreesPerPixel = [1 / c, -1 / l, 1 / h], o) {
          var p = fe * Math.tan(e * fe) / u,
            f = s / ge * p,
            d = f / l * h;
          a.pixelsPerDegree2 = [0, -c * p / 2, f], a.pixelsPerMeter2 = [d, 0, d];
        }
        return a;
      }(Jt(Jt(t))).pixelsPerMeter[2], Object.freeze(Jt(Jt(t))), t;
    }
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Xt(t, e);
    }(e, Me), Ht(e, [{
      key: "projectFlat",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale;
        return be(t, e);
      }
    }, {
      key: "unprojectFlat",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.scale;
        return _e(t, e);
      }
    }, {
      key: "getMapCenterByLngLatPosition",
      value: function value(t) {
        var e = t.lngLat,
          n = we(t.pos, this.pixelUnprojectionMatrix),
          r = ce([], be(e, this.scale), function (t, e) {
            return t[0] = -e[0], t[1] = -e[1], t;
          }([], n));
        return _e(ce([], this.center, r), this.scale);
      }
    }, {
      key: "getLocationAtPoint",
      value: function value(t) {
        return this.getMapCenterByLngLatPosition({
          lngLat: t.lngLat,
          pos: t.pos
        });
      }
    }, {
      key: "fitBounds",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = this.width,
          i = this.height,
          o = Oe(Object.assign({
            width: r,
            height: i,
            bounds: t
          }, n)),
          a = o.longitude,
          s = o.latitude,
          u = o.zoom;
        return new e({
          width: r,
          height: i,
          longitude: a,
          latitude: s,
          zoom: u
        });
      }
    }]), e;
  }(),
  Pe = ["top-left", "top-right", "bottom-left", "bottom-right"],
  Se = function (t) {
    var e, r;
    function i() {
      for (var e, r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
        i[o] = arguments[o];
      }
      return (e = t.call.apply(t, [this].concat(i)) || this).geocoder = null, e.cachedResult = null, e.initializeGeocoder = function () {
        var t = e.getMapboxMap(),
          n = e.getContainerNode(),
          r = e.props,
          i = r.inputValue,
          o = r.render,
          a = r.getItemValue,
          s = r.onInit,
          u = r.position,
          c = {
            accessToken: r.mapboxApiAccessToken,
            origin: r.origin,
            zoom: r.zoom,
            flyTo: !1,
            placeholder: r.placeholder,
            proximity: r.proximity,
            trackProximity: r.trackProximity,
            collapsed: r.collapsed,
            clearAndBlurOnEsc: r.clearAndBlurOnEsc,
            clearOnBlur: r.clearOnBlur,
            bbox: r.bbox,
            types: r.types,
            countries: r.countries,
            minLength: r.minLength,
            limit: r.limit,
            language: r.language,
            filter: r.filter,
            localGeocoder: r.localGeocoder,
            reverseGeocode: r.reverseGeocode,
            enableEventLogging: r.enableEventLogging,
            marker: !1
          };
        o && "function" == typeof o && (c.render = o), a && "function" == typeof a && (c.getItemValue = a), e.geocoder = new Ut(c), e.subscribeEvents(), n ? n.appendChild(e.geocoder.onAdd(t)) : t.addControl(e.geocoder, Pe.find(function (t) {
          return u === t;
        })), null != i ? e.geocoder.setInput(i) : e.cachedResult && e.geocoder.setInput(e.cachedResult.place_name), (e.cachedResult || null != i) && e.showClearIcon(), s(e.geocoder);
      }, e.showClearIcon = function () {
        e.geocoder._clearEl.style.display = "block";
      }, e.getMapboxMap = function () {
        var t = e.props.mapRef;
        return t && t.current && t.current.getMap() || null;
      }, e.getContainerNode = function () {
        var t = e.props.containerRef;
        return t && t.current || null;
      }, e.subscribeEvents = function () {
        e.geocoder.on("clear", e.handleClear), e.geocoder.on("loading", e.handleLoading), e.geocoder.on("results", e.handleResults), e.geocoder.on("result", e.handleResult), e.geocoder.on("error", e.handleError);
      }, e.unsubscribeEvents = function () {
        e.geocoder.off("clear", e.handleClear), e.geocoder.off("loading", e.handleLoading), e.geocoder.off("results", e.handleResults), e.geocoder.off("result", e.handleResult), e.geocoder.off("error", e.handleError);
      }, e.removeGeocoder = function () {
        var t = e.getMapboxMap();
        e.unsubscribeEvents(), t && t.removeControl && e.getMapboxMap().removeControl(e.geocoder), e.geocoder = null;
      }, e.handleClear = function () {
        e.cachedResult = null, e.props.onClear();
      }, e.handleLoading = function (t) {
        e.props.onLoading(t);
      }, e.handleResults = function (t) {
        e.props.onResults(t);
      }, e.handleResult = function (t) {
        var r = t.result,
          i = e.props,
          o = i.onViewportChange,
          a = i.onResult,
          s = r.bbox,
          u = r.center,
          c = r.properties,
          l = (void 0 === c ? {} : c).short_code,
          h = u[0],
          p = u[1],
          f = {
            fr: {
              name: "France",
              bbox: [[-4.59235, 41.380007], [9.560016, 51.148506]]
            },
            us: {
              name: "United States",
              bbox: [[-171.791111, 18.91619], [-66.96466, 71.357764]]
            },
            ru: {
              name: "Russia",
              bbox: [[19.66064, 41.151416], [190.10042, 81.2504]]
            },
            ca: {
              name: "Canada",
              bbox: [[-140.99778, 41.675105], [-52.648099, 83.23324]]
            }
          },
          d = e.getMapboxMap().getContainer().getBoundingClientRect(),
          y = d.width,
          g = d.height,
          m = e.geocoder.options.zoom,
          v = function v(t, e) {
            return new je(e).fitBounds(t);
          };
        try {
          !f[l] && s ? m = v([[s[0], s[1]], [s[2], s[3]]], {
            width: y,
            height: g
          }).zoom : f[l] && (m = v(f[l].bbox, {
            width: y,
            height: g
          }).zoom);
        } catch (t) {
          console.warn("following result caused an error when trying to zoom to bbox: ", r), m = e.geocoder.options.zoom;
        }
        o({
          longitude: h,
          latitude: p,
          zoom: m,
          transitionInterpolator: new n(),
          transitionDuration: 3e3
        }), a(t), e.cachedResult = r, e.geocoder._typeahead.selected = null, e.showClearIcon();
      }, e.handleError = function (t) {
        e.props.onError(t);
      }, e;
    }
    r = t, (e = i).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
    var o = i.prototype;
    return o.componentDidMount = function () {
      this.initializeGeocoder();
    }, o.componentWillUnmount = function () {
      this.removeGeocoder();
    }, o.componentDidUpdate = function () {
      this.removeGeocoder(), this.initializeGeocoder();
    }, o.getGeocoder = function () {
      return this.geocoder;
    }, o.render = function () {
      return null;
    }, i;
  }(t);
Se.propTypes = {
  mapRef: j.object.isRequired,
  containerRef: j.object,
  onViewportChange: j.func,
  mapboxApiAccessToken: j.string.isRequired,
  inputValue: j.string,
  origin: j.string,
  zoom: j.number,
  placeholder: j.string,
  proximity: j.object,
  trackProximity: j.bool,
  collapsed: j.bool,
  clearAndBlurOnEsc: j.bool,
  clearOnBlur: j.bool,
  bbox: j.array,
  types: j.string,
  countries: j.string,
  minLength: j.number,
  limit: j.number,
  language: j.string,
  filter: j.func,
  localGeocoder: j.func,
  reverseGeocode: j.bool,
  enableEventLogging: j.bool,
  render: j.func,
  getItemValue: j.func,
  position: j.oneOf(Pe),
  onInit: j.func,
  onClear: j.func,
  onLoading: j.func,
  onResults: j.func,
  onResult: j.func,
  onError: j.func
}, Se.defaultProps = {
  onViewportChange: function onViewportChange() {},
  origin: "https://api.mapbox.com",
  zoom: 16,
  placeholder: "Search",
  trackProximity: !1,
  collapsed: !1,
  clearAndBlurOnEsc: !1,
  clearOnBlur: !1,
  minLength: 2,
  limit: 5,
  reverseGeocode: !1,
  enableEventLogging: !0,
  position: "top-right",
  onInit: function onInit() {},
  onClear: function onClear() {},
  onLoading: function onLoading() {},
  onResults: function onResults() {},
  onResult: function onResult() {},
  onError: function onError() {}
};
export default Se;